

















































































import { Component } from "vue-property-decorator";

import { images } from "@/core/constants";

import AppVue from "@/AppVue.vue";

@Component
export default class SidebarCpt extends AppVue {
  isCollapsed = true;

  mounted() {
    window.addEventListener("resize", () => this.resolveCollapsed());
    this.resolveCollapsed();
  }

  get routeName() {
    return this.$route.name;
  }

  get version() {
    return process.env.VUE_APP_VERSION;
  }

  get eiLogo() {
    return images.eiLogo;
  }

  get dovetailLogo() {
    return images.dovetailLogo;
  }

  get imiLogo() {
    return images.imiLogo;
  }

  private resolveCollapsed() {
    setInterval(() => {
      const element = document.querySelector("body") as any;
      this.isCollapsed = element.clientWidth < 1200;
    }, 100);
  }
}
